module.exports = __webpack_public_path__ + "img/V75.39daffbc.jpg";